module.exports = __webpack_public_path__ + "static/img/75063D_1_2_R_20210918_fit.bf8657f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/75063D_1_2_R_20210918_fit.png
// module id = F7Ic
// module chunks = 0